import { render, staticRenderFns } from "./EditAsset.vue?vue&type=template&id=70729d70&scoped=true&"
import script from "./EditAsset.vue?vue&type=script&lang=js&"
export * from "./EditAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70729d70",
  null
  
)

export default component.exports